/**
 * C 端专用暴露云字体列表 npm 包接口的文件
 * 因 B 端没有云字体功能，此文件需要在 B 端整体 mock 掉，古给每一个 npm 包暴露出的接口做一层封装
 */
import { scheduleAfterFirstSlideDisplay } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import type {
    initFontList as originalInitFontList,
    isCustomFont as originalIsCustomFont,
    isVipFont as originalIsVipFont,
    triggerFontDownload as originalTriggerFontDownload,
    setFontNameAlias as originalSetFontNameAlias,
} from '@tencent/docs-scenario-components-font-list';

type ArgumentType<F extends Function> = F extends (...args: infer A) => any ? A : never;

export const getFontListModule = () => scheduleAfterFirstSlideDisplay(() => import('@tencent/docs-scenario-components-font-list'));


// eslint-disable-next-line max-len
export async function initFontList(...args: ArgumentType<typeof originalInitFontList>): Promise<void> {
    return getFontListModule().then(module => module.initFontList(...args));
}

// eslint-disable-next-line max-len
export async function isCustomFont(...args: ArgumentType<typeof originalIsCustomFont>): Promise<boolean> {
    return getFontListModule().then(module => module.isCustomFont(...args));
}

// eslint-disable-next-line max-len
export async function isVipFont(...args: ArgumentType<typeof originalIsVipFont>): Promise<boolean> {
    return getFontListModule().then(module => module.isVipFont(...args));
}

// eslint-disable-next-line max-len
export async function triggerFontDownload(...args: ArgumentType<typeof originalTriggerFontDownload>): Promise<boolean> {
    return getFontListModule().then(module => module.triggerFontDownload(...args));
}

// eslint-disable-next-line max-len
export async function setFontNameAlias(...args: ArgumentType<typeof originalSetFontNameAlias>): Promise<void> {
    return getFontListModule().then(module => module.setFontNameAlias(...args));
}
